module.exports = __webpack_public_path__ + "img/8.913de521.jpg";